import React from 'react';
import styled from 'styled-components';
import { navy, white } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const QuestionSVG = styled(Icon).attrs({ viewBox: '0 0 40 40' })``;

function Question({ color = navy, innerColor = white, ...props }) {
    return (
        <QuestionSVG
            data-test="icon-question"
            {...props}
        >
            <path
                d="M20,40C9,40,0,31,0,20C0,9,9,0,20,0c11,0,20,9,20,20C40,31,31,40,20,40z"
                fill={color}
            />
            <path
                d="M21.6,24.1h-4.9v-6.6l3.2-0.5c1.8,0,3.2-1.1,3.2-2.8s-1.4-3.3-3.2-3.3s-3.2,1.5-3.2,3.3h-4.9c0-4.3,3.8-8.2,8.1-8.2c4.3,0,8.3,3.9,8.3,8.2c0,4-2.7,6.8-6.6,7.3V24.1z"
                fill={innerColor}
            />
            <rect
                fill={innerColor}
                height="4.9"
                width="4.9"
                x="16.7"
                y="29.1"
            />
        </QuestionSVG>
    );
}

export {
    Question as default,
    Question,
};
